import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(300);
const savedMinimalSchema = z.string().max(300);
const schema = z.string().min(1).max(300);
const savedSchema = z.string().min(1).max(300);
const jsonSchema = z.string();
/**
 * 機関名かな(値オブジェクト)のメタデータ。
 *
 * 機関の名称かな。 */
export const institutionNameKanaMeta = new ValueObjectMetaString(
  "InstitutionNameKana",
  "\u6A5F\u95A2\u540D\u304B\u306A",
  messageId("lbl.\u6A5F\u95A2\u540D\u304B\u306A"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
